var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closePopup,
          expression: "closePopup"
        }
      ],
      staticClass: "FilterList"
    },
    [
      _c(
        "div",
        {
          staticClass: "FilterList--button",
          style: { height: _vm.height, width: _vm.width },
          on: { click: _vm.togglePopup }
        },
        [
          _c("span", [_vm._v(_vm._s(_vm.label))]),
          _vm._v(" "),
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("\n            arrow_drop_down\n        ")
          ])
        ]
      ),
      _vm._v(" "),
      _vm.isPopupOpen
        ? [
            _c(
              "div",
              { staticClass: "FilterList--list" },
              _vm._l(_vm.dataList, function(option) {
                return _c(
                  "checkbox",
                  {
                    key: option.id,
                    staticClass: "FilterList--list-checkbox",
                    attrs: {
                      "checkbox-id": option.id,
                      checked: option.checked
                    },
                    on: {
                      "update:checked": function($event) {
                        return _vm.onChecked(option.title, $event)
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(option.title) +
                        "\n            "
                    )
                  ]
                )
              }),
              1
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65ceebef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65ceebef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/controls/FilterList.vue
// module id = null
// module chunks = 